import { defineStore } from "pinia";

export const usePreview2DStore = defineStore("preview2d", {
  state: () => ({
    image: null
  }),

  getters: {
    getPreview2D(state) {
      return state.image;
    }
  },

  actions: {
    setPreview2D(payload) {
      this.image = payload;
    }
  }
});
